/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "../js/components/MattelVideoPlayer.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../js/components/MattelVideoPlayer.js":
/*!*********************************************!*\
  !*** ../js/components/MattelVideoPlayer.js ***!
  \*********************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _shared_videoPlayer_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/videoPlayer_config */ "../js/shared/videoPlayer_config.js");

window.MattelVideoPlayer = {};
MattelVideoPlayer.ooPlayerInstances = {};
MattelVideoPlayer.ooyalaApiLoaded = false;

(function () {
  MattelVideoPlayer.playerScenarios = {
    thumbnailNreload: false,
    thumbnailNonreload: false,
    singlePlayer: false,
    multiplayer: false
  };
  var haveVideoToLoad = false;
  var videoContainers = [];
  var generatedExtId = "";
  var completedVideo = false;
  var wrapperJSInitialized = false; // creating and binding ooyala plugins like css,js

  function renderOoyalaApi() {
    videoContainers = document.getElementsByClassName("ooyala-video-player");
    MattelVideoPlayer.ooPlayerInstances.players = []; // $('head').append('<link rel="stylesheet" type="text/css" href="//static.mattel.com/videoplayer/src/js/v4/ooyala-overridden.css">');
  }
  /**
   For each player in the page, setting the scenario based on the following player Tag Element ID
   @divId: (passed as parameter)player Tag Element ID
   @Functionality: Detects and sets the player scenario for further player playback.
  **/


  function scenarioDetector(divId, indx) {
    MattelVideoPlayer.playerScenarios = {
      thumbnailNreload: $("#".concat(divId)).attr('data-contains-thumbnailNreload') != null ? $("#".concat(divId)).attr('data-contains-thumbnailNreload') : undefined,
      thumbnailNonreload: $("#".concat(divId)).attr('data-contains-thumbnailNonreload') != null ? $("#".concat(divId)).attr('data-contains-thumbnailNonreload') : undefined,
      singlePlayer: $("#".concat(divId)).attr('data-singlePlayer') != null ? $("#".concat(divId)).attr('data-singlePlayer') : undefined,
      multiplayer: $("#".concat(divId)).attr('data-multiplePlayer') != null ? $("#".concat(divId)).attr('data-multiplePlayer') : undefined,
      customPlayer: $("#".concat(divId)).attr('data-customPlayer') != null ? $("#".concat(divId)).attr('data-customPlayer') : undefined,
      slidingPlayerOnPage: $('[data-slidertype ="flexSlider"]').length ? $('[data-slidertype ="flexSlider"]') : $('[data-slidertype ="bxSlider"]').length ? $('[data-slidertype ="bxSlider"]') : undefined
    };
    scenarioBasedConfig(divId, indx);
    eventBinders();
  } // Based on the detected scenario, do some config on detected scenarios


  function scenarioBasedConfig(divId, indx) {
    if (MattelVideoPlayer.playerScenarios.thumbnailNonreload) {
      /**
      This block prevents the default behavior of anchor tag, as the scenario set as THUMBNAIL-NON-RELOAD 
      (i.e., loads the video without reloading the page, A fallback to prevent default behavior)
      **/
      MattelVideoPlayer.startVideoPlayer(divId, $("#".concat(divId)).data('videoId'), indx);
      var listEl = $('.thumbnail-video-list .video-list-item a');

      if (listEl != null) {
        // binding click event based on the jquery version
        if (typeof $.fn.live == "function") {
          listEl.live('click', function (e) {
            /** ---for jquery < 1.7 --**/
            e.preventDefault();
          });
        } else if (typeof $.fn.on == "function") {
          /** ---for jquery >= 1.7 --**/
          listEl.on('click', function (e) {
            e.preventDefault();
          });
        }
      }
    } else if (MattelVideoPlayer.playerScenarios.thumbnailNreload) {
      MattelVideoPlayer.startVideoPlayer(divId, $("#".concat(divId)).data('videoId'), indx);
    } else if (MattelVideoPlayer.playerScenarios.customPlayer) {
      MattelVideoPlayer.startVideoPlayer(divId, $("#".concat(divId)).data('videoId'), indx, true);
    } else {
      haveVideoToLoad ? MattelVideoPlayer.startVideoPlayer(divId, generatedExtId, indx) : MattelVideoPlayer.startVideoPlayer(divId, $("#".concat(divId)).data('videoId'), indx);
    }
  } // slider Overlay for navigations 


  MattelVideoPlayer.playerNavigationControl = function (currentSlider) {
    $(MattelVideoPlayer.ooPlayerInstances.players).each(function (index, item) {
      item.pause();
    });
    if (typeof currentSlider == "undefined") return false;
    MattelVideoPlayer.ooPlayerInstances.players[currentSlider].play();
  }; // Pre-configures and generates the unique ooyala player ID for each player in the page


  function ooVideoSetters() {
    if ($('[ooyala-video-slider]').length > 0) {
      MattelVideoPlayer.ooPlayerInstances = {};
      MattelVideoPlayer.ooPlayerInstances.players = [];
      playerLoading();
    } else if ($('[ooyala-Overlay]').hasClass('activeOverlay')) {
      playerLoading();
    } else if (!$('div[ooyala-Overlay]').length) {
      playerLoading();
    }
  } // Generates and sets the unique id attribute for player containers


  function playerLoading() {
    for (var i = 0; i < videoContainers.length; i++) {
      videoContainers[i].setAttribute('id', "video-container-".concat(i + 1));

      if (!haveVideoToLoad) {
        scenarioDetector(videoContainers[i].getAttribute('id'), i);
      } else {
        scenarioDetector(videoContainers[i].getAttribute('id'), i);
        break;
      }
    }
  } // Binds the events for the thumbnails if available in the page


  function eventBinders() {
    /** This block helps in handling events for "thumbnailNonreload" scenarios 
        (i.e., clicking on thumbnail, loads appropriate video in the player)
    **/
    if (typeof $.fn.live == "function") {
      if (MattelVideoPlayer.playerScenarios.thumbnailNonreload) {
        $('.thumbnail-video-list .video-list-item').live('click', function (ev) {
          playerBinding(this);
          $('.video-list-item').removeClass('oo-thumbnail-active');
          $(ev.currentTarget).addClass('oo-thumbnail-active');
        });
      }

      $('.replay[op-control-replay]').live('click', function (ev) {
        MattelVideoPlayer.ooPlayerInstances.players[0].play();
      });
    } else if (typeof $.fn.on == "function") {
      /** ---for jquery >= 1.7 --**/
      if (MattelVideoPlayer.playerScenarios.thumbnailNonreload) {
        $(document).on('click', '.thumbnail-video-list .video-list-item,.video-gallery-slides .video-gallery-slide', function (ev) {
          playerBinding(this);
          $('.video-list-item').removeClass('oo-thumbnail-active');
          $(ev.currentTarget).addClass('oo-thumbnail-active');
        });
      }

      $(document).on('click', '.replay[op-control-replay]', function (ev) {
        MattelVideoPlayer.ooPlayerInstances.players[0].play();
      });
    }
  } // Binds the thumbnail events for the thumbnails non-relaoding page 


  function playerBinding(curEle) {
    var externalId = $(curEle).data('videoId'),
        contentId = externalId,
        playerClass = document.getElementsByClassName("ooyala-video-player");
    var playerIndex;

    if (MattelVideoPlayer.ooPlayerInstances.players.length == 1) {
      MattelVideoPlayer.playerEmbedCode(MattelVideoPlayer.ooPlayerInstances.players[0], contentId);
      $('[data-contains-thumbnailnonreload=true]').data("videoId", contentId);
      return false;
    }

    for (var j = 0; j < playerClass.length; j++) {
      for (var i = 0; i < curEle.parentElement.children.length; i++) {
        if (playerClass[j].getAttribute('data-video-id') == curEle.parentElement.children[i].getAttribute('data-video-id')) {
          var splittedVal = playerClass[j].getAttribute('id').split("-");
          playerIndex = playerClass[j].getAttribute('id').split("-")[splittedVal.length - 1] - 1;
          MattelVideoPlayer.playerEmbedCode(MattelVideoPlayer.ooPlayerInstances.players[playerIndex], contentId);
          break;
        }
      }
    }
  }

  function html5PlayerCorrections(player, index) {
    var hostName = location.hostname;

    if ((hostName.indexOf("kids.barbie.com") != -1 || hostName.indexOf("play.barbie.com") != -1) && !MattelVideoPlayer.ooPlayerInstances.players[index].binding) {
      MattelVideoPlayer.ooPlayerInstances.players[index].catalog = {
        getVideo: function getVideo(videoId, cb) {
          cb(undefined, videoId.toString().replace("ref:", ""));
        },
        load: function load(videoId) {
          MattelVideoPlayer.playerEmbedCode(MattelVideoPlayer.ooPlayerInstances.players[index], videoId);
        }
      };
      MattelVideoPlayer.ooPlayerInstances.players[index].binding = true;
    }
  }

  MattelVideoPlayer.playerEmbedCode = function (_player, _contentid) {
    Object(_shared_videoPlayer_config__WEBPACK_IMPORTED_MODULE_0__["updatePlayer"])(_player, _contentid);
  };

  MattelVideoPlayer.isPlaying = function (video) {
    if (!video) return false;
    return !!(video.currentTime() > 0 && !video.paused() && !video.ended() && video.readyState() > 2);
  }; // Instantiates ooyala Player


  MattelVideoPlayer.startVideoPlayer = function (divId, externalId, playerIndex, isCustomPlayer, cb) {
    var playingVideo = false,
        previousEvent = '',
        playerLen = MattelVideoPlayer.ooPlayerInstances.players.length;

    if (playerIndex == undefined) {
      playerIndex = playerLen + 1;
    }

    return Object(_shared_videoPlayer_config__WEBPACK_IMPORTED_MODULE_0__["createPlayer"])(divId, externalId, function (player) {
      $("#sub-" + divId).css({
        "width": '100%',
        "padding-top": '56.25%',
        "height": 'auto'
      });
      updatePlayerStyle("#sub-" + divId); //console.log(player);

      /** tracking code for player ready/play **/

      player.on("playing", function (event) {
        if (previousEvent != event) {
          if (!playingVideo) {
            playingVideo = true;
            completedVideo = true;
          } else {// OOEventTracking('Play',MattelVideoPlayer.ooPlayerInstances.players[0].getCurrentItemTitle());
          }
        }

        previousEvent = event;
      });
      /** tracking code for player paused **/

      player.on("pause", function (event) {
        if (playingVideo && previousEvent != event && previousEvent != 'played') {
          previousEvent = event;
        }
      });
      /** tracking code for player end/completed **/

      player.on("ended", function (event) {
        if (MattelVideoPlayer.playerScenarios.thumbnailNonreload && previousEvent != event && completedVideo) {
          completedVideo = false;
          MattelVideoPlayer.ooPlayerInstances.players[0].pause();
          /** --- calling the function for autoplaying next video --- **/

          var curId = $('[data-contains-thumbnailnonreload=true]').data('video-id');

          if (!curId) {
            return;
          }

          var curEle = $(".thumbnail-video-list .video-list-item[data-video-id=\"".concat(curId.indexOf('extId') != -1 ? curId.split(':')[1] : curId, "\"]"));

          if (($(curEle).next() && $(curEle).length) > 0) {
            $(curEle).next().click();
          } else {
            $('.thumbnail-video-list .video-list-item:first-child').click();
          }
        }

        playingVideo = false;
        previousEvent = event;
      });

      if (!playerIndex) {
        playerIndex = 0;
      }

      MattelVideoPlayer.ooPlayerInstances.players[playerIndex] = player;
      player.html5Player && html5PlayerCorrections(player, playerIndex);
      typeof cb == "function" && cb(player);
    }, isCustomPlayer);
  };

  var updatePlayerStyle = function updatePlayerStyle(divId) {
    var brandName = getBrandName();

    if (brandName === "allaboardforglobalgoals") {
      $(divId).css('z-index', '1');
    }
  }; // Destroy the ooyala player 


  MattelVideoPlayer.destroyVideos = function (player) {
    if (player) {
      player.dispose();
    } else {
      $(MattelVideoPlayer.ooPlayerInstances.players).each(function (index, item) {
        item.dispose();
      });
    }

    MattelVideoPlayer.ooyalaApiLoaded = false;
  };
  /*** Slider Actions Begins***/


  MattelVideoPlayer.sliderActions = {};
  MattelVideoPlayer.sliderActions = {
    'findVideoPos': function findVideoPos(self, sliderType) {
      if (sliderType != "bxslider") {
        //flexslider
        this.nthVideo = -1; // Detects the slide where the video resides.

        this.elementId = "";
        var that = this;
        $(self.selector).each(function (key, item) {
          if (!$(item).hasClass('clone')) {
            if ($(item).find('.player-wrapper').length) {
              that.nthVideo++;
              that.elementId = $(item).find('.ooyala-video-player').attr('id');
            }

            if ($(item).hasClass('flex-active-slide')) {
              return false;
            }
          }
        });
      } else if (sliderType == "bxslider") {//bxslider
        //not required as of now
      }
    },
    'beforeAction': function beforeAction(slider, self, previousSlide, currentSlide, sliderType) {
      if (sliderType != "bxslider") {
        //flexslider
        // chk whether the current slide contains video or not.
        var slideHasVideo = $('.flex-active-slide').find('.player-wrapper').length ? true : false;
        MattelVideoPlayer.sliderActions.findVideoPos(self, sliderType);
        console.log(this.nthVideo);

        if (slideHasVideo) {
          // if video found in current slide, pause it.
          var x = this.elementId;
          var y = MattelVideoPlayer.ooPlayerInstances.players.filter(function (v, k) {
            return x == v.getElementId();
          });

          if (y.length > 0) {
            y[0].pause();
          } //MattelVideoPlayer.ooPlayerInstances.players[this.nthVideo].pause();


          slider.play();
        }
      } else if (sliderType == "bxslider") {//bxslider
        //not required as of now   
      }
    },
    'afterAction': function afterAction(slider, self, previousSlide, currentSlide, sliderType) {
      if (sliderType != "bxslider") {
        //flexslider
        // chk whether the current slide contains video or not.
        var slideHasVideo = $('.flex-active-slide').find('.player-wrapper').length ? true : false;
        MattelVideoPlayer.sliderActions.findVideoPos(self, sliderType);

        if (slideHasVideo) {
          // if video found in current slide, play video and pause slider.
          //MattelVideoPlayer.ooPlayerInstances.players[this.nthVideo].play();
          var x = this.elementId;
          var y = MattelVideoPlayer.ooPlayerInstances.players.filter(function (v, k) {
            return x == v.getElementId();
          });

          if (y.length > 0 && !y[0].isPlaying()) {
            y[0].play();
            slider.pause(); //slider.play();
            //setTimeout(function(){
            //slider.pause();
            //$('[data-slidertype ="flexSlider"]').flexslider('pause')
            //},1000);
          }
        } else {
          // if video is not in current slider play slider
          slider.play();
        }
      } else if (sliderType == "bxslider") {
        //bxslider
        $('.bx-active-slide').removeClass('bx-active-slide');
        self.parent().find('> li').eq(currentSlide).addClass('bx-active-slide');

        if (self.parent().find('li').eq(currentSlide).find('.player-wrapper').length) {
          MattelVideoPlayer.ooPlayerInstances.players.forEach(function (player, indx) {
            if (self.find('.ooyala-video-player').attr('id') == player.elementId) {
              player.play();
            } else {
              player.pause();
            }

            player.on("ended", function (event) {
              $(self).parentsUntil('[data-slidertype="bxSlider"]').find('.bx-next').trigger('click');
            });
          });
        }
      }
    },
    'startAction': function startAction(slider, self, previousSlide, currentSlide, sliderType) {
      if (sliderType != "bxslider") {
        //flexslider
        // 1. Initially pause the slider
        slider.pause(); // Go through all the player instances 

        MattelVideoPlayer.ooPlayerInstances.players.forEach(function (player, indx) {
          MattelVideoPlayer.ooPlayerInstances.players[0].play(); // Handle Video Pause Event 

          player.on("pause", function (event) {
            slider.play();
            $('[data-slidertype ="flexSlider"]').play();
          }); // Handle Video Completed Playing Event 

          player.on("ended", function (event) {
            $('[data-slidertype ="flexSlider"]').flexslider(slider.currentSlide + 1 < slider.pagingCount ? slider.currentSlide + 1 : 0);
            slider.play();
          });
          player.on("playing", function (event) {// slider.pause();
          });
        });
      } else if (sliderType == "bxslider") {
        //bxslider  
        $(self).parent().find('li').eq(1).addClass('bx-active-slide');
        $(self).parent().find('> li').addClass('slide');
        $(self).parent().find('.bx-clone').removeClass('slide'); // Go through all the player instances 

        MattelVideoPlayer.ooPlayerInstances.players.forEach(function (player, indx) {
          MattelVideoPlayer.ooPlayerInstances.players[0].play(); // Handle Video Pause Event

          player.on("pause", function (event) {
            slider.startAuto();
          }); // Handle Video Completed Playing Event

          player.on("ended", function (event) {//slider.goToNextSlide();
          }); // Handle the player ready to play Event

          player.on("loadedmetadata", function (event) {
            slider.stopAuto();
          });
          player.on("playing", function (event) {
            slider.stopAuto();
          });
        });
      }
    }
  };
  /*** Slider Actions Ends***/
  // initiate the functionality to be triggered on page load

  var windowOnLoad = function windowOnLoad() {
    if (MattelVideoPlayer.ooyalaApiLoaded) {
      var getHiddenVideoId = document.getElementById('charComponentUri');

      if (getHiddenVideoId != null) {
        var videoListItem = document.getElementsByClassName('video-list-item');

        if (getHiddenVideoId.value == "") {
          generatedExtId = videoListItem[0].getAttribute('data-video-id');
        } else {
          for (var i = 0; i < videoListItem.length; i++) {
            if (videoListItem[i].getAttribute('videoTcmId') == getHiddenVideoId.value) {
              generatedExtId = videoListItem[i].getAttribute('data-video-id');
              break;
            }
          }
        }
        /**  
            Flagging this variable for thumbnail reload
            (i.e, clicking thumbnail, reloads the page and play the clicked video on load)
        **/


        haveVideoToLoad = true;
      }

      ooVideoSetters();
    }
  };

  var getBrandName = function getBrandName() {
    return (location.host.match(/([^.]+)\.\w{2,3}(?:\.\w{2})?$/) || [])[1];
  };

  var getBrandConfig = function getBrandConfig(brandName) {
    var obj = {};

    switch (brandName) {
      case 'bobthebuilder':
        obj = {
          playerId: "default",
          accountId: "6058004139001"
        };
        break;

      case 'thomasandfriends':
      case 'allaboardforglobalgoals':
        obj = {
          playerId: "default",
          accountId: "6058004139001"
        };
        break;

      case 'fisher-price':
        obj = {
          playerId: "default",
          accountId: "6057994541001"
        };
        break;

      default:
        obj = {
          playerId: "eWOMBjeN",
          accountId: "6057994534001"
        };
        break;
    }

    if ($("#video-playlist").val() == "true") {
      obj.playerId = "leG4nss9G";
    }

    return obj;
  };

  var wrapperJSInit = function wrapperJSInit() {
    Object(_shared_videoPlayer_config__WEBPACK_IMPORTED_MODULE_0__["init"])(function (status) {
      if (status) {
        wrapperJSInitialized = true;
        MattelVideoPlayer.init();
      }
    });
  }; // ooyala API initialization


  MattelVideoPlayer.init = function () {
    if (!MattelVideoPlayer.ooyalaApiLoaded && !_shared_videoPlayer_config__WEBPACK_IMPORTED_MODULE_0__["configuration"].isBrightCovePlayer) {
      MattelVideoPlayer.ooyalaApiLoaded = true;
      renderOoyalaApi();
      windowOnLoad();
    }
  };

  Object(_shared_videoPlayer_config__WEBPACK_IMPORTED_MODULE_0__["configuration"])(getBrandConfig(getBrandName())); // configuration({
  //     playerId: "default",
  //     accountId: "6057994542001"
  // })

  if (!wrapperJSInitialized) {
    wrapperJSInit();
  }

  $(function () {
    if (!wrapperJSInitialized) {
      wrapperJSInit();
    }

    if (!MattelVideoPlayer.ooyalaApiLoaded) {
      MattelVideoPlayer.init();
      MattelVideoPlayer.ooyalaApiLoaded = true;
    }
  });
})();

/***/ }),

/***/ "../js/shared/videoPlayer_config.js":
/*!******************************************!*\
  !*** ../js/shared/videoPlayer_config.js ***!
  \******************************************/
/*! exports provided: init, configuration, createPlayer, updatePlayer */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configuration", function() { return configuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlayer", function() { return createPlayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePlayer", function() { return updatePlayer; });
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// plroms
var playerDataAttrs = $("#video-hidden-properties").length ? $("#video-hidden-properties")[0].dataset : {};
var config = {
  defaultPlayer: playerDataAttrs.playerName || "deluxe",
  player: {
    apiLoaded: false,
    players: []
  },
  error: {},
  isAEMPage: $("body").hasClass("basicpage"),
  isManualTrigger: $("body").hasClass("basicpage") ? false : true,
  dependencies: ["jQuery", "_"],
  el: '.ooyala-video-player,.video-component,.with-video-player,.reusability-video-component,#video-player-component,.video-player-container,.video-wrapper,[med-type="ooyala"]'
};
var self;
var playerConfigs = {};

var playerAction = function playerAction(playerName) {
  switch (playerName) {
    case "brightcove":
      playerConfigs = new brightcovePlayer();
      break;

    case "deluxe":
      playerConfigs = new deluxePlayer();
      break;
  }

  ;
}; // Brightcove player


var brightcovePlayer = function brightcovePlayer() {
  self = this;
  this.apiLoaded = false;
  this.stylesheetUrl = "";
  this.playerProps = {};
  this.players = [];
  this.pluginCheckCnt = 0;

  if (!config.isManualTrigger) {
    this.settings(this.getBrandConfig(this.getBrandName()));
    this.init.call();
  }
};

brightcovePlayer.prototype = {
  settings: function settings(obj) {
    self.playerProps.playerId = self.playerProps.playerId || obj && obj.playerId;
    self.playerProps.accountId = self.playerProps.accountId || obj && obj.accountId;
    return {
      playerId: self.playerProps.playerId,
      accountId: self.playerProps.accountId
    };
  },
  getBrandConfig: function getBrandConfig(brandName) {
    var obj = {};

    switch (brandName) {
      case 'fisher-price':
        obj = {
          playerId: "default",
          accountId: "6057994541001"
        };
        break;

      case 'americangirl':
      case 'american-girl-play':
        obj = {
          playerId: "default",
          accountId: '6058004226001'
        };
        break;

      case 'fisher-price-kids':
        obj = {
          playerId: "default",
          accountId: '6057994542001'
        };
        break;

      default:
        obj = {
          playerId: "default",
          accountId: "6057994534001"
        };
        break;
    }

    return obj;
  },
  getBrandName: function getBrandName() {
    var hiddenPageName = $("#businessSiteName");

    if (hiddenPageName.length) {
      return hiddenPageName.val();
    }

    return window.location.href.indexOf('ag') != -1 ? "americangirl" : (location.host.match(/([^.]+)\.\w{2,3}(?:\.\w{2})?$/) || [])[1];
  },
  updatePlayer: function updatePlayer(playerId, videoId) {
    var videoIdLen = videoId.toString().length;
    var updatedVideoId = videoIdLen >= 32 ? "ref:".concat(videoId) : videoId;
    var currentPlayer = _typeof(playerId) == "object" ? playerId : self.players[playerId];

    if (!currentPlayer) {
      console.log("%c playerId is not available", "color:red");
      return;
    }

    currentPlayer.catalog.getVideo(updatedVideoId, function (error, video) {
      // Load the video object into the player
      currentPlayer.catalog.load(video);
      currentPlayer.play();
    });
  },
  waitForAPILoad: function waitForAPILoad(callBack) {
    window.setTimeout(function () {
      if (typeof videojs !== "undefined") {
        callBack();
      } else {
        self.pluginCheckCnt++;

        if (self.pluginCheckCnt > 20) {
          console.log("%c BrightCove API not loaded/failed.", "color:red");
          return;
        }

        self.waitForAPILoad(callBack);
      }
    }, 500);
  },
  createPlayerElement: function createPlayerElement(obj) {
    var videoId = obj.videoId ? obj.videoId.toString().length : obj.playerId.toString().length;
    var updatedVideoId = videoId >= 32 ? "ref:".concat(obj.playerId) : obj.playerId;
    document.getElementById(obj.divId).innerHTML = "<video-js id=\"sub-".concat(obj.divId, "\" ").concat(obj.mute ? "muted=true" : '', " data-video-id=\"").concat(updatedVideoId, "\"  data-account=\"").concat(self.settings().accountId, "\" data-player=\"").concat(self.settings().playerId, "\" data-embed=\"default\" class=\"video-js\" controls playsinline></video-js>");
  },
  createPlaylistElement: function createPlaylistElement(obj) {
    var videoId = obj.videoId.toString().length;
    var updatedVideoId = videoId >= 32 ? "ref:".concat(obj.playerId) : obj.playerId;
    document.getElementById(obj.divId).innerHTML = "<div class=\"vjs-playlist-player-container\"><video-js id=\"sub-".concat(obj.divId, "\" ").concat(obj.mute ? "muted=true" : '', " data-playlist-id=\"").concat(updatedVideoId, "\" data-video-id=\"\"  data-account=\"").concat(self.settings().accountId, "\" data-player=\"").concat(self.settings().playerId, "\" data-embed=\"default\" class=\"video-js\" controls></video-js></div>");
  },
  createPlayer: function createPlayer(divId, playerId, cb, isPlaylist) {
    if (Object.keys(config.error).length) {
      return;
    }

    var dataset = $("#".concat(divId))[0].dataset;
    self.waitForAPILoad(function () {
      var autoplay = dataset.autoplay == "true" ? true : false;
      var mute = dataset.mute == "true" ? 1 : 0; // any: The player will first try to call play. If that fails, mute the player and call play.

      var obj = {
        divId: divId,
        playerId: playerId,
        autoplay: autoplay,
        videoId: dataset.videoId,
        mute: mute
      };
      isPlaylist ? self.createPlaylistElement(obj) : self.createPlayerElement(obj);
      bc("sub-".concat(divId));
      var myPlayer = videojs.getPlayer("sub-".concat(divId));
      myPlayer.ready(function () {
        self.players[playerId] = this;
        cb(this);
      });
      myPlayer.on('loadedmetadata', function () {
        if ((obj.autoplay == true || obj.autoplay == "true") && self.isScrolledIntoView($("#".concat(divId)))) {
          myPlayer.play();
        }
      });
    });
  },
  isScrolledIntoView: function isScrolledIntoView(elem) {
    var elementTop = $(elem).offset().top;
    var elementBottom = elementTop + $(elem).outerHeight();
    var viewportTop = $(window).scrollTop() - 200;
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  },
  loadViaRequireJS: function loadViaRequireJS(url) {
    window.require.config({
      'paths': {
        'bc': url
      },
      waitSeconds: 30
    });

    window.require(['bc'], function () {
      self.apiLoaded = true;
    });
  },
  bindPlayerAPI: function bindPlayerAPI() {
    if (typeof videojs == "function") {
      self.apiLoaded = true;
      return;
    }

    var apiUrl = "//players.brightcove.net/".concat(self.settings().accountId, "/").concat(self.settings().playerId, "_default/index.min.js");

    jQuery.cachedScript = function (url, options) {
      options = $.extend(options || {}, {
        dataType: "script",
        cache: true,
        url: url
      });
      return jQuery.ajax(options);
    }; // Usage


    $.cachedScript(apiUrl).done(function (script, textStatus) {
      if (typeof videojs != "function" && typeof define == "function") {
        self.loadViaRequireJS(apiUrl);
      } else {
        self.apiLoaded = true;
      }
    }).fail(function (err) {
      config.error['Account/Player_ID_Mismatch'] = true;
      console.log("%c BrightCove PlayerId/Account id seems to be incorrect.", "color:red");
    });
    $('head').append("<link rel=\"stylesheet\" type=\"text/css\" href=\"".concat(self.stylesheetUrl, "\">"));
  },
  init: function init(cb) {
    if (Object.keys(config.error).length || !$(config.el).length) {
      typeof cb == "function" && cb(false);
      return;
    }

    self.bindPlayerAPI();
    typeof cb == "function" && cb(true);
  }
}; // Deluxe Player

var deluxePlayer = function deluxePlayer() {
  self = this;
  this.apiLoaded = false;
  this.playerTheme = "bc-theme";
  this.pluginCheckCnt = 0;
  this.requireJSCheckCnt = 0;
  //this.cdnDomain = playerDataAttrs.hostName || "https://mattel-sites-stage64.adobecqms.net";
  //this.folderPath = "".concat(this.cdnDomain, "/content/dam/mattel/mattel-global/global/brightcove-legacy");
  //this.apiUrl = "".concat("https://cdn.shopify.com/s/files/1/0561/4790/2654/t/63/assets/video-hls.min.js?v=14832853138085907171677856031");
  //this.cssUrl = "".concat(this.folderPath, "/video-hls.min.css");
  this.blockedAutoPlay = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || !!window.MSInputMethodContext && !!document.documentMode;

  if (!config.isManualTrigger) {
    this.init.call();
  }

  this.videoDomain = "https://images.mattel.net";
};

deluxePlayer.prototype = {
  settings: function settings(videoId) {
    return {
      src: "".concat(self.videoDomain, "/video/upload/sp_full_hd_wifi/videos-mattel/").concat(videoId, ".m3u8"),
      type: "application/x-mpegURL",
      //poster: "".concat(self.videoDomain, "/image/upload/f_auto,q_auto/videos-mattel/thumbnail/").concat(videoId, "/").concat(self.getPosterParams(videoId), ".jpg")
      poster: "".concat(self.videoDomain, "/image/upload/f_auto,q_auto/videos-mattel/thumbnail/").concat(videoId, ".jpg")
    };
  },
  getPosterParams: function getPosterParams(videoId) {
    var idInString = videoId.toString();
    return idInString.length >= 32 || idInString.startsWith("6") ? "poster" : videoId;
  },
  testImage: function testImage(URL) {
    var tester = new Image();

    tester.onerror = function (err) {
      console.log("%c ".concat(err.srcElement.src, ", poster image not available in dynamic media"), 'color:red');
    };

    tester.src = URL;
  },
  updatePlayer: function updatePlayer(playerId, videoId) {
    var currentPlayer = _typeof(playerId) == "object" ? playerId : self.players[playerId];
    var params = self.settings(videoId);
    var src = params.src,
        poster = params.poster;

    if (!currentPlayer) {
      console.log("%c playerId is not available", "color:red");
      return;
    } // var tracks = currentPlayer.textTracks();
    // var metadataTrack;


    currentPlayer.tech_ && currentPlayer.tech_.clearTracks("text");
    currentPlayer.resetControlBarUI_();
    currentPlayer.loadTech_(currentPlayer.options_.techOrder[0], null);
    currentPlayer.remoteTextTracks();
    currentPlayer.remoteTextTrackEls();
    currentPlayer.poster_ = poster;
    currentPlayer.techCall_('setPoster', poster);
    currentPlayer.trigger('posterchange');
    currentPlayer.src(src);
    currentPlayer.load();
    currentPlayer.ready(function () {
      currentPlayer.play();
    });
    currentPlayer.on("error", function (e) {
      e.stopImmediatePropagation();
    });
  },
  createPlayerElement: function createPlayerElement(divId, obj, cb) {
    var params = self.settings(obj.videoId);
    var src = params.src,
        type = params.type,
        poster = params.poster;
    self.testImage(poster);
    document.getElementById(divId).innerHTML = "<video id=\"sub-".concat(divId, "\" ").concat(poster ? 'poster=' + poster : '', " preload=\"auto\" crossorigin=\"anonymous\" controls class=\"video-js ").concat(self.playerTheme, " vjs-default-skin\" controls><source src=\"").concat(src, "\" type=\"").concat(type, "\"></video>");
    var options = {
      html5: {
        textTrackSettings: false,
        nativeTextTracks: false,
        hlsjsConfig: {// Put your hls.js config here
        }
      }
    }; // setup beforeinitialize hook

    if (typeof videojs.Html5Hlsjs == "function") {
      videojs.Html5Hlsjs.addHook('beforeinitialize', function (videojsPlayer, hlsjsInstance) {// here you can interact with hls.js instance and/or video.js playback is initialized
      });
    }

    var player = videojs("sub-".concat(divId), options);
    player.ready(function () {
      obj.autoplay && self.isScrolledIntoView($(player.el_)) && !self.blockedAutoPlay && player.play();
    });
    player.on("error", function (e) {
      $(player.el_).find(".vjs-error-display .vjs-modal-dialog-content").html("Video ID : <u>".concat(obj.videoId, "</u> not migrated yet"));
      e.stopImmediatePropagation();
    });

    const callbacksExecuted = {
      25: false,
      50: false,
      75: false,
      100: false,
    };

    let hasStarted = false;

    const videoTitle = document.getElementById(divId).getAttribute('data-video-name');
    const runDataLayer = (status) => {
      window.dataLayer.push({
        event: 'video_play_status',
        ecommerce: {
          items: [
            {
              video_name: videoTitle,
              video_status: status,
            },
          ],
        },
      });
    };

    const checkPlaybackPercentage = (percentage) => {
      Object.keys(callbacksExecuted).forEach((key) => {
        const percent = parseInt(key, 10);
        if (percentage >= percent && !callbacksExecuted[key]) {
          runDataLayer(`${percent}%`);
          callbacksExecuted[key] = true;
        }
      });
    };

    player.on('play', function () {
      if (!hasStarted) {
        runDataLayer('start');
        hasStarted = true;
      }
    });

    player.on('timeupdate', function () {
      const percentage = (player.currentTime() / player.duration()) * 100;
      checkPlaybackPercentage(percentage);
    });

    player.html5Player = true;
    cb(player);
  },
  waitForAPILoad: function waitForAPILoad(callBack) {
    window.setTimeout(function () {
      if (typeof videojs !== "undefined") {
        callBack();
      } else {
        self.pluginCheckCnt++;

        if (self.pluginCheckCnt > 20) {
          console.log("%c HLS API not loaded/failed.", "color:red");
          return;
        }

        self.waitForAPILoad(callBack);
      }
    }, 500);
  },
  createPlaylistElement: function createPlaylistElement(obj) {
    document.getElementById(obj.divId).innerHTML = "";
  },
  createPlayer: function createPlayer(divId, playerId, cb, isPlaylist) {
    if (Object.keys(config.error).length) {
      return;
    }

    var dataset = $("#".concat(divId))[0].dataset;
    var autoplay = dataset.autoplay == "true" ? true : false;
    var mute = dataset.mute == "true" ? 1 : 0;
    var obj = {
      divId: divId,
      playerId: playerId,
      autoplay: autoplay,
      videoId: dataset.videoId || playerId,
      mute: mute
    };
    self.waitForAPILoad(function () {
      self.createPlayerElement(divId, obj, function (player) {
        cb(player);
      });
    });
  },
  loadCSSFile: function loadCSSFile() {
    if (self.cssUrl) {
      $('head').append("<link rel=\"stylesheet\" type=\"text/css\" href=\"".concat(self.cssUrl, "?123\">"));
    }
  },
  isScrolledIntoView: function isScrolledIntoView(elem) {
    var elementTop = $(elem).offset().top;
    var elementBottom = elementTop + $(elem).outerHeight();
    var viewportTop = $(window).scrollTop() - 200;
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  },
  bindPlayerAPI: function bindPlayerAPI() {
    if (typeof videojs == "function") {
      self.apiLoaded = true;
      return;
    }

    jQuery.cachedScript = function (url, options) {
      options = $.extend(options || {}, {
        dataType: "script",
        cache: true,
        url: url
      });
      return jQuery.ajax(options);
    };

    $.cachedScript(self.apiUrl).done(function (script, textStatus) {
      self.apiLoaded = true;
    }).fail(function (err) {
      config.error['HLSJSNotFound'] = true;
      console.log("%c Deluxe PlayerId framework (HLS) not loaded.", "color:red");
    });
  },
  init: function init(cb) {
    if (Object.keys(config.error).length || !$(config.el).length) {
      typeof cb == "function" && cb(false);
      return;
    }

    self.loadCSSFile();
    self.bindPlayerAPI();
    typeof cb == "function" && cb(true);
  }
};

var playerActionInit = function playerActionInit() {
  playerAction(config.defaultPlayer);
};

playerActionInit();
var init = playerConfigs['init'];
var configuration = playerConfigs['settings'];
var createPlayer = playerConfigs['createPlayer'];
var updatePlayer = playerConfigs['updatePlayer'];


/***/ })

/******/ });
//# sourceMappingURL=MattelVideoPlayer.js.map
